import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
// Model

@Injectable()
export class PhotoGalleryService {
	events: Subject<any> = new Subject();
}
